import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
    "inline-flex items-center rounded-md border-transparent border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
    {
        variants: {
            variant: {
                default: "bg-primary text-primary-foreground shadow-sm hover:bg-primary/80",
                secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
                destructive:
                    "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/80",
                outline: "border-border text-foreground",
                lightBlue: "bg-blue-100 text-blue-500 hover:bg-blue-200",
                lightYellow: "bg-yellow-100 text-yellow-500 hover:bg-yellow-200",
                lightGreen: "bg-green-100 text-green-500 hover:bg-green-200",
                lightPurple: "bg-purple-100 text-purple-500 hover:bg-purple-200",
                lightRed: "bg-red-100 text-red-500 hover:bg-red-200",
                lightOrange: "bg-amber-100 text-amber-500 hover:bg-amber-200",
                muted: "bg-muted text-foreground hover:bg-muted/80 border-border",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    },
);

export interface BadgeProps
    extends React.HTMLAttributes<HTMLDivElement>,
        VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps): JSX.Element {
    return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
